import includes from "lodash/includes";
import { Component } from "react";
import type { IntlShape } from "react-intl";
import ListItem from "../../components/ListItem";
type Props = {
  popularCompetitions: Record<string, any>;
  otherCompetitions: Record<string, any>;
  selectedComps: Record<string, any>;
  intl: IntlShape;
  toggleLeagueSelected: (...args: Array<any>) => any;
};

class CompetitionsLists extends Component<Props> {
  render() {
    const {
      popularCompetitions,
      otherCompetitions,
      selectedComps,
      intl,
      toggleLeagueSelected,
    } = this.props;
    return (
      <div className="select-competitions__lists">
        {popularCompetitions && popularCompetitions.length > 0 ? (
          <div>
            <span>
              {intl.formatMessage({
                id: "global-events-navigation-popular-leagues",
              })}
            </span>
            <ul className="select-competitions__list">
              {popularCompetitions &&
                popularCompetitions.map((comp, index) => {
                  return (
                    <ListItem
                      key={index}
                      comp={comp}
                      selected={includes(selectedComps, comp.navigationNodeId)}
                      props={this.props}
                      toggleLeagueSelected={toggleLeagueSelected}
                    />
                  );
                })}
            </ul>
          </div>
        ) : (
          <div></div>
        )}
        {otherCompetitions && otherCompetitions.length > 0 ? (
          <div>
            <span>
              {intl.formatMessage({
                id: "global-events-navigation-other-leagues",
              })}
            </span>
            <ul className="select-competitions__list">
              {otherCompetitions &&
                otherCompetitions.map((comp, index) => {
                  return (
                    <ListItem
                      key={index}
                      comp={comp}
                      selected={includes(selectedComps, comp.navigationNodeId)}
                      props={this.props}
                      toggleLeagueSelected={toggleLeagueSelected}
                    />
                  );
                })}
            </ul>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default CompetitionsLists;
